/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ day: NonNullable<unknown>, movement: NonNullable<unknown> }} Prescription_Notice_Primary_IsolationInputs */

const en_us2_prescription_notice_primary_isolation = /** @type {(inputs: Prescription_Notice_Primary_IsolationInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day}: no multi-joint ${i?.movement} exercise fits your equipment, so the day opens with a single-joint one.`)
};

const pt_br2_prescription_notice_primary_isolation = /** @type {(inputs: Prescription_Notice_Primary_IsolationInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day}: nenhum exercício composto de ${i?.movement} cabe no seu equipamento, então o dia começa com um isolado.`)
};

const es_419_prescription_notice_primary_isolation = /** @type {(inputs: Prescription_Notice_Primary_IsolationInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day}: ningún ejercicio multiarticular de ${i?.movement} se ajusta a tu equipo, así que el día empieza con uno de aislamiento.`)
};

const pt_pt2_prescription_notice_primary_isolation = /** @type {(inputs: Prescription_Notice_Primary_IsolationInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day}: nenhum exercício composto de ${i?.movement} se adequa ao teu equipamento, por isso o dia começa com um isolado.`)
};

const fr_fr2_prescription_notice_primary_isolation = /** @type {(inputs: Prescription_Notice_Primary_IsolationInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day} : aucun exercice polyarticulaire « ${i?.movement} » ne convient à ton équipement, la journée commence donc par un monoarticulaire.`)
};

const de_de2_prescription_notice_primary_isolation = /** @type {(inputs: Prescription_Notice_Primary_IsolationInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day}: Keine Grundübung für ${i?.movement} passt zu deiner Ausstattung, daher beginnt der Tag mit einer Isolationsübung.`)
};

const it_it2_prescription_notice_primary_isolation = /** @type {(inputs: Prescription_Notice_Primary_IsolationInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day}: nessun esercizio multiarticolare di ${i?.movement} è compatibile con la tua attrezzatura, quindi il giorno inizia con un monoarticolare.`)
};

/**
* | output |
* | --- |
* | "{day}: no multi-joint {movement} exercise fits your equipment, so the day opens with a single-joint one." |
*
* @param {Prescription_Notice_Primary_IsolationInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const prescription_notice_primary_isolation = /** @type {((inputs: Prescription_Notice_Primary_IsolationInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Prescription_Notice_Primary_IsolationInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_prescription_notice_primary_isolation(inputs)
	if (locale === "es-419") return es_419_prescription_notice_primary_isolation(inputs)
	if (locale === "pt-PT") return pt_pt2_prescription_notice_primary_isolation(inputs)
	if (locale === "fr-FR") return fr_fr2_prescription_notice_primary_isolation(inputs)
	if (locale === "de-DE") return de_de2_prescription_notice_primary_isolation(inputs)
	if (locale === "it-IT") return it_it2_prescription_notice_primary_isolation(inputs)
	return en_us2_prescription_notice_primary_isolation(inputs)
});
export { prescription_notice_primary_isolation as "prescription.notice.primary_isolation" }